"use client";

import { ErrorComponent } from "@/shared/ui";

export default ErrorComponent;
